// De bakjes van de privacyverklaring-stand (eigenaarsbesluit 9 sep 2026), los
// van lib/crm/candidate-sql.mjs: de bellijst in de browser
// (components/HomeV2/CallLists.js) heeft alleen deze lijst nodig, en een import uit
// candidate-sql.mjs zette 70 KB SQL-tekst plus zijn imports in de clientchunk
// (gemeten 8 okt 2026). privacyStatusSqlExpr in candidate-sql.mjs levert precies
// deze waarden; wie er een toevoegt, doet dat op beide plekken.
// Vijfde bakje (26 okt 2026): 'Geaccepteerd bij sollicitatie', het privacyvinkje op het
// sollicitatieformulier (candidate_gdpr.accepted_via = 'sollicitatie').
// Lees de bakjes op naam, nooit op positie in PRIVACY_STATUS_OPTIONS.
export const PRIVACY_NOT_SENT = 'Niet verstuurd';
export const PRIVACY_SENT = 'Verstuurd, niet geaccepteerd';
export const PRIVACY_ACCEPTED = 'Verstuurd, geaccepteerd';
export const PRIVACY_ACCEPTED_APPLICATION = 'Geaccepteerd bij sollicitatie';
export const PRIVACY_REJECTED = 'Verstuurd, afgewezen';
export const PRIVACY_STATUS_OPTIONS = [PRIVACY_NOT_SENT, PRIVACY_SENT, PRIVACY_ACCEPTED, PRIVACY_ACCEPTED_APPLICATION, PRIVACY_REJECTED];
// Alle bakjes die als geaccepteerd tellen: wie 'geaccepteerd' filtert of toont, leest deze.
export const PRIVACY_ACCEPTED_BUCKETS = Object.freeze([PRIVACY_ACCEPTED, PRIVACY_ACCEPTED_APPLICATION]);

// De vier standen van de eigenaar (26 okt 2026) waarop elk scherm filtert: elk een
// of meer bakjes. Het volledige filter (zoekcatalogus) houdt de vijf bakjes.
export const PRIVACY_STATE_KEYS = Object.freeze(['accepted', 'sent', 'rejected', 'notsent']);
export const PRIVACY_STATE_BUCKETS = Object.freeze({
  accepted: PRIVACY_ACCEPTED_BUCKETS,
  sent: Object.freeze([PRIVACY_SENT]),
  rejected: Object.freeze([PRIVACY_REJECTED]),
  notsent: Object.freeze([PRIVACY_NOT_SENT]),
});
export const PRIVACY_STATE_LABELS = Object.freeze({
  accepted: 'Privacy geaccepteerd',
  sent: 'Privacy verstuurd',
  rejected: 'Privacy afgewezen',
  notsent: 'Geen privacy ontvangen',
});
// Bakje -> stand ('accepted' | 'sent' | 'rejected' | 'notsent'); onbekend telt als notsent.
export function privacyStateOf(bucket) {
  for (const k of PRIVACY_STATE_KEYS) if (PRIVACY_STATE_BUCKETS[k].includes(bucket)) return k;
  return 'notsent';
}
